<template>
  <div class="bg-white px-4 py-5 border-b border-gray-200 rounded-md shadow sm:px-6">
    <slot></slot>
  </div>
</template>





<script>
export default {
  name: "Card"
}
</script>